import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { TooltipMenu, Icon, Button } from '@haldor/ui';
import { getActiveSchool } from 'helpers/localstorage';
import { onRouteBack } from 'actions/header';
import './Header.scss';

var Header = /*#__PURE__*/function (_Component) {
  _inherits(Header, _Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "goBack", function (event) {
      event.preventDefault();
      console.log(_this.props.history);

      _this.props.history.goBack();

      return;
    });

    _defineProperty(_assertThisInitialized(_this), "renderAction", function (action, index) {
      switch (action.type) {
        case 'button':
          return /*#__PURE__*/React.createElement(Button, {
            key: 'action-' + index,
            type: action.buttonType,
            disabled: action.disabled,
            onClick: action.onClick
          }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
            name: action.icon
          }) : null, action.value);

        case 'dropDown':
          return /*#__PURE__*/React.createElement(TooltipMenu, {
            key: 'action-' + index,
            trigger: /*#__PURE__*/React.createElement(Button, {
              disabled: action.disabled
            }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
              name: action.icon
            }) : null, action.value)
          }, action.subButtons ? action.subButtons.map(function (subAction, index) {
            return /*#__PURE__*/React.createElement(TooltipMenu.Item, {
              onClick: function onClick() {
                return subAction.onClick(true);
              },
              key: 'subAction-' + index
            }, subAction.value);
          }) : null);

        case 'icon':
          return /*#__PURE__*/React.createElement(Link, {
            to: "#",
            key: 'action-' + index,
            className: "header-action",
            "data-tooltip": action.tooltip,
            onClick: action.onClick
          }, action.icon != null ? /*#__PURE__*/React.createElement(Icon, {
            name: action.icon
          }) : null);

        default:
          return null;
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var activeSchool = this.props.user.schools.find(function (school) {
        return school.id == getActiveSchool(_this2.props.user.id);
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "teams-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, this.props.settings.backButton ? /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: this.goBack,
        className: "c--button back"
      }, /*#__PURE__*/React.createElement("i", {
        className: "cl-container"
      }, /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          transform: 'rotate(90deg)'
        },
        className: "a-90"
      }, /*#__PURE__*/React.createElement("path", {
        id: "Path_50",
        "data-name": "Path 50",
        className: "cls-1",
        d: "M11.361,1.4,6.38,5.9,1.4,1.4"
      })))) : null, this.props.title != null ? /*#__PURE__*/React.createElement("div", {
        className: "page-title",
        title: this.props.title
      }, activeSchool != null ? activeSchool.title + ' / ' : null, this.props.title) : null), /*#__PURE__*/React.createElement("div", {
        className: "content right"
      }, /*#__PURE__*/React.createElement("div", {
        className: "actions",
        id: "teams-header-actions"
      }, this.props.settings.actions != null ? this.props.settings.actions.map(this.renderAction) : null))));
    }
  }]);

  return Header;
}(Component);

function mapStateToProps(state) {
  return {
    user: state.user.currentUser,
    title: state.Header.title,
    settings: state.Header
  };
}

export default withRouter(connect(mapStateToProps, {
  onRouteBack: onRouteBack
})(Header));